import { useSelector } from 'react-redux';
import { AnimatePresence } from 'framer-motion';
import { ConfigProvider, ThemeConfig } from 'antd';

// helpers
import './i18n';

// services
import { RootState } from 'stores/store';

//components
import App from 'App';

//routes

function Main() {
	const language = useSelector((state: RootState) => state.language);

	const theme: ThemeConfig = {
		token: {
			colorPrimary: '#2884EF',
			colorPrimaryActive: '#3689eb',
			colorSuccess: '#50CD89',
			colorError: '#ff4d4f',
		},
	};

	return (
		<ConfigProvider componentSize="large" theme={theme} direction={language == 'ar' ? 'rtl' : 'ltr'}>
			<AnimatePresence mode="wait">
				<App />
			</AnimatePresence>
		</ConfigProvider>
	);
}

export default Main;
